export default __webpack_public_path__ + "static/media/component-info-2.5212a3a6.png";